import baseMixin from './baseMixin'
import {
    styler,
    tween,
    composite,
    chain,
    delay,
    stagger,
    spring
} from 'popmotion'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'data-education-graphic'
    },

    methods: {
        setStyler() {
            this.rootStyler = styler(this.baseElement)
            this.pillars = this.stylerGroup('#paths path')
            this.balls = this.stylerGroup('#circles path')
        },

        initAction() {
            return tween({ from: 1, to: 0 })
        },

        pillarsAnimation() {
            let pillars = this.pillars.map(_ =>
                tween({
                    from: { pathLength: 0 },
                    to: { pathLength: 100 },
                    duration: 1000
                })
            )
            return stagger(pillars, 100)
        },

        ballsAnimation() {
            let balls = this.balls.map(_ =>
                chain(
                    delay(1000),
                    tween({ from: { y: 0 }, to: { y: -30 } }),
                    spring({
                        from: { y: -30 },
                        to: { y: 0 },
                        stiffness: 200,
                        damping: 20
                    })
                )
            )
            return stagger(balls, 100)
        },

        animationAction() {
            return composite({
                root: chain(delay(100), tween({ from: 0, to: 1 })),
                pillars: this.pillarsAnimation(),
                balls: this.ballsAnimation()
            })
        },

        initReaction(v) {
            this.rootStyler.set({ opacity: v })
        },

        animationReaction(values) {
            values.root && this.rootStyler.set({ opacity: values.root })

            values.pillars &&
                values.pillars.map((v, i) => this.pillars[i].set(v))

            values.balls && values.balls.map((v, i) => this.balls[i].set(v))
        }
    }
}
